module.exports = __webpack_public_path__ + "img/Алматы қ..8abcbb96.png";